import {
  AssignableType,
  BasketballEventType,
  Task,
  TaskEvent,
  TaskableType,
  UserBasic,
} from '@hefe/models';
import { Descriptions } from 'antd';
import { useMemo } from 'react';
import TaskAssignmentSelectComponent from '../../../../tasks/components/task-assignment-select/task-assignment-select.component';

interface EventDetailsTeamTasksComponentProps {
  eventType: BasketballEventType;
  eventId: number;
  tasks?: Task[];
  homeGame?: boolean;
  coaches: UserBasic[];
  players: UserBasic[];
  teamPlayers: any;
  teamId: number;
}

export default function EventDetailsTeamTasksComponent(
  props: EventDetailsTeamTasksComponentProps
) {
  const { tasks, homeGame, eventType, eventId } = props;

  const tasksList = useMemo(() => {
    if (!tasks) return null;

    return tasks
      .filter((task) => {
        if (eventType === BasketballEventType.GAME) {
          return homeGame ? task.at_home_games : task.at_away_games;
        } else {
          return task.at_practices;
        }
      })
      .map((task) => {
        const taskId = `team_${task.id}`;
        const taskEvent = {
          assignments: task?.assignments ?? [],
          id: `${eventType}_${eventId}`,
        } as TaskEvent;

        return (
          <Descriptions.Item label={task.name} key={task.id}>
            <TaskAssignmentSelectComponent
              assignments={task?.assignments ?? []}
              assignableType={AssignableType.ALL}
              event={taskEvent}
              type={TaskableType.BASKETBALL_TEAM}
              taskId={taskId}
              teamId={props.teamId}
              disabled={!task?.allow_interaction}
              task={task}
            />
          </Descriptions.Item>
        );
      });
  }, [tasks, eventType, homeGame, eventId, props.teamId]);

  return (
    <Descriptions column={1} size="small" bordered>
      {tasksList}
    </Descriptions>
  );
}
